/**
 * Extracts a team invite token from signup/teams URLs, including when nested in a redirect param.
 */
export function extractInviteTokenFromUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  try {
    const parsed = url.startsWith("http") ? new URL(url) : new URL(url, "https://placeholder.local");
    const token = parsed.searchParams.get("token");
    if (token) return token;
  } catch {
    // Fall through to regex parsing for malformed URLs.
  }

  const match = url.match(/[?&]token=([^&]+)/);
  if (!match?.[1]) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}
